import React, { useEffect, useState } from 'react';

import { loadRemoteWebComponent } from 'views/NavigationWizard/module-federation-config';
import { useRuntimeConfig } from 'config/useRuntimeConfig';

type Status = 'loading' | 'done' | 'error';

export const BrPurposeNavigationInstructionsWizard = () => {
  const [status, setStatus] = useState<Status>('loading');
  const runtimeConfig = useRuntimeConfig();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await loadRemoteWebComponent(
          'pcm-br-purpose-frontend-view',
          `${runtimeConfig.configData.iframeUrls.brPurposeIframe}/remoteEntry.js`,
          'pcm-br-purpose-navigation-instructions-section-element',
        );
        if (!cancelled) setStatus('done');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to load remote web component:', e);

        if (!cancelled) setStatus('error');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [runtimeConfig.configData.iframeUrls.brPurposeIframe]);

  if (status === 'loading') return <p className="placeholder">Loading…</p>;
  if (status === 'error') return <p className="placeholder">An error occurred.</p>;
  return <pcm-br-purpose-navigation-instructions-section-element version="0.0.1" />;
};
